<template>
  <div class="courses-single-content">
    <template v-if="quizInfo">
      <!-- Congratulations Message -->
      <div
        v-if="
          quizInfo.quiz.takers.score &&
          quizInfo.quiz.takers.completed &&
          hasCertificate
        "
        class="certificate-success-message"
        style="
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 12px;
          padding: 40px;
          margin-bottom: 30px;
          color: white;
          text-align: center;
        "
      >
        <div style="font-size: 48px; margin-bottom: 20px">🎉</div>
        <h2
          style="
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 15px;
            color: white;
          "
        >
          {{ $t("congratulations") }}
        </h2>
        <p
          style="
            font-size: 20px;
            margin-bottom: 10px;
            color: white;
            opacity: 0.95;
          "
        >
          {{ $t("course_completed") }}
        </p>
        <div
          style="
            background: rgba(255, 255, 255, 0.2);
            border-radius: 8px;
            padding: 20px;
            margin: 25px auto;
            max-width: 500px;
          "
        >
          <div
            style="
              font-size: 18px;
              font-weight: 600;
              margin-bottom: 10px;
              color: white;
            "
          >
            ✓ {{ $t("certificate_received") }}
          </div>
          <p
            style="
              font-size: 14px;
              color: white;
              opacity: 0.9;
              line-height: 1.6;
            "
          >
            {{ $t("certificate_notification") }}
          </p>
        </div>
        <div
          style="
            display: flex;
            gap: 15px;
            justify-content: center;
            margin-top: 30px;
            flex-wrap: wrap;
          "
        >
          <router-link
            to="/certificates"
            class="courses-btn"
            style="
              background: white;
              color: #667eea;
              padding: 15px 30px;
              border-radius: 8px;
              font-weight: 600;
              text-decoration: none;
              display: inline-flex;
              align-items: center;
              gap: 8px;
            "
          >
            <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path
                d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
              />
            </svg>
            <div>{{ $t("go_to_profile") }}</div>
          </router-link>
          <a
            v-if="
              submitQuizData &&
              submitQuizData.certificates &&
              submitQuizData.certificates.pdf
            "
            :href="submitQuizData.certificates.pdf"
            target="_blank"
            class="courses-btn"
            style="
              background: rgba(255, 255, 255, 0.3);
              color: white;
              padding: 15px 30px;
              border-radius: 8px;
              font-weight: 600;
              text-decoration: none;
              display: inline-flex;
              align-items: center;
              gap: 8px;
              border: 2px solid white;
            "
          >
            <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
              <path
                d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
              />
            </svg>
            <div>{{ $t("view_certificate") }}</div>
          </a>
        </div>
      </div>

      <div
        class="courses-single-title courses-title-frame courses-lesson-title"
      >
        <i class="fa-title"></i>
        <h2>{{ quizInfo.quiz.title }}</h2>
      </div>
      <div
        class="courses-test-btn"
        v-if="quizInfo.quiz.takers.score && quizInfo.quiz.takers.completed"
      >
        <p class="courses-test-arrow">
          <b style="font-size: 22px; color: #33ec72">{{
            quizInfo.quiz.takers.score
          }}</b>
          / 100
        </p>
        <a href="#!" class="courses-test-reply success" @click.prevent>{{
          $t("passed_test")
        }}</a>
      </div>
      <div
        class="courses-test-btn"
        v-else-if="
          quizInfo.quiz.takers.score && !quizInfo.quiz.takers.completed
        "
      >
        <p class="courses-test-arrow">
          <b style="font-size: 22px; color: tomato"
            >{{ quizInfo.quiz.takers.score }}
          </b>
          / 100
        </p>
        <router-link
          :to="`/test/${$route.params.slug}`"
          class="courses-test-reply"
          style="width: 260px"
          >{{ $t("retake_test") }} <i class="fa-arrow-line"></i
        ></router-link>
        <a href="#!" class="courses-test-arrow">
          {{ quizInfo.quiz.takers.chances_left }} / {{ quizInfo.quiz.chances }}
        </a>
      </div>
      <div class="courses-home-bar" v-else>
        <router-link
          :to="`/test/${$route.params.slug}`"
          class="courses-test-start"
          ><i class="fa-play"></i> {{ $t("start_test") }}</router-link
        >
      </div>
    </template>
  </div>
</template>

<script>
export default {
  async mounted() {
    try {
      await this.$store.dispatch("getQuizBySlug", this.$route.params.slug);
      await this.$store.dispatch("getCourse", this.$route.query.id);
    } catch (e) {
      this.$store.commit("setNotification", "no-quiz");
    }
  },
  beforeRouteUpdate(to, from, next) {
    try {
      this.$store.dispatch("getQuizBySlug", to.params.slug);
      next();
    } catch (e) {
      this.$store.commit("setNotification", "no-quiz");
    }
  },
  computed: {
    quizInfo() {
      return this.$store.getters.getQuizInfo;
    },
    submitQuizData() {
      return this.$store.getters.getSubmitQuiz;
    },
    hasCertificate() {
      return this.submitQuizData && this.submitQuizData.certificates;
    },
    lang() {
      return this.$store.getters.lang;
    },
  },
};
</script>
